import { Injectable } from '@angular/core';

type Tree = {
  [key: string]: Tree;
};

@Injectable({ providedIn: 'root' })
export class GlobalAnalyticsContext {
  public globalContext: Array<[parent: string[] | undefined, context: string[]]> = [];

  public registerContext(
    parentContext: string[] | undefined,
    leafContext: string,
    newContext: string[],
  ): void {
    this.globalContext = [...this.globalContext, [parentContext, newContext]];
  }

  public unregisterContext(
    parentContext: string[] | undefined,
    leafContext: string,
    newContext: string[],
  ): void {
    this.globalContext = this.globalContext.filter(context => context[1] !== newContext);
  }

  public buildContextTree(parentContext?: string[]): Tree {
    const rootContexts = this.globalContext.filter(context =>
      parentContext ? context[0] === parentContext : !context[0],
    );
    return Object.fromEntries(
      rootContexts.map(([parent, context]) => [
        context[context.length - 1],
        this.buildContextTree(context),
      ]),
    );
  }

  public getFlatContext(): string[] {
    const arrWithDuplicates = <string[]>(
      this.globalContext.flatMap(context => context.flat()).filter(v => !!v)
    );
    return Array.from(new Set(arrWithDuplicates));
  }
}
